import { delta, driftTone } from '../lib/format';

/**
 * The number this whole console exists to show: how far reality has drifted from
 * the plan. Rendered identically everywhere so the eye learns one shape.
 */
export function Delta({ seconds }: { seconds: number | null | undefined }) {
  if (seconds === null || seconds === undefined) {
    return <span className="delta" data-tone="idle">--</span>;
  }
  // Early is not a problem, so it never gets a warning colour.
  const tone = seconds < 0 ? 'ok' : driftTone(seconds);
  return (
    <span className="delta" data-tone={tone}>
      {delta(seconds)}
    </span>
  );
}

export function StatusDot({ status, risk }: { status: string; risk?: string }) {
  const color =
    status === 'completed'
      ? 'var(--ok)'
      : status === 'failed'
        ? 'var(--late)'
        : status === 'on_site' || status === 'en_route'
          ? 'var(--accent)'
          : risk === 'late'
            ? 'var(--late)'
            : risk === 'tight'
              ? 'var(--warn)'
              : 'var(--idle)';
  return <span className="dot" style={{ background: color }} />;
}
